import { Routes } from "@angular/router";

export const routes: Routes = [
	{
		path: "",
		children: [
			{
				path: "",
				loadComponent: () => import('./kudoshub-vs-neverbounce.component').then(m => m.KudoshubVsNeverbounceComponent),
				data: {
					title: "#1 NeverBounce Alternative - KudosHub",
					description:
						"Trusted by top teams, KudosHub offers 99% accuracy, AI email scoring, and 1.5x better pricing than NeverBounce. Compare now and start with 3,000 free validations.",
					keywords: "email list validation",
					ogTitle: "#1 NeverBounce Alternative - KudosHub",
					ogDesc:
						"Trusted by top teams, KudosHub offers 99% accuracy, AI email scoring, and 1.5x better pricing than NeverBounce. Compare now and start with 3,000 free validations.",
					ogImage: "https://kudoshub.com/theme/images/og-images/logo.webp",
					ogUrl: "https://kudoshub.com/neverbounce-alternative",
					twitterTitle: "#1 NeverBounce Alternative - KudosHub",
					twitterDesc:
						"Trusted by top teams, KudosHub offers 99% accuracy, AI email scoring, and 1.5x better pricing than NeverBounce. Compare now and start with 3,000 free validations.",
					twitterImage: "https://kudoshub.com/theme/images/og-images/logo.webp",
					dateModified: "2025-09-04T12:00:00+05:30"
				},
			},
		],
	},
];